<!-- 

Send periodic email (boolean switch or boolean override drop-down)
Include only new (boolean switch)
Frequency (drop-down - OnceWeekly, OnceDaily, TwiceDaily)
Weekday (drop-down - available for OnceWeekly only)
Times (one time for OnceWeekly/OnceDaily, two times for TwiceDaily)

Unfortunately the form layout here has to be duplicated within this template
for each display mode because the DOM structure for the fields in each display 
mode's host differ too much to be able to consolidate without over-complicating
a single template

-->

<!-- **** Template for the User Preferences host **** -->

<ng-template [ngIf]="displayMode == DM.UserPreferences">
  <div class="row">
    <label for="{{sendPeriodicEmailUP.controlId}}"
            class="col-8 sentence">{{sendPeriodicEmailUP.controlLabelText}}</label>
    <div class="col-4" style="display:inline-block;">
      <p-dropdown id="{{sendPeriodicEmailUP.controlId}}"
                  hideDropdownOnScroll
                  [(ngModel)]="sendPeriodicEmailUP.value.current"
                  [options]="sendPeriodicEmailUP.options"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [style]="{'width': '100%'}"
                  (onChange)="sendPeriodicEmailUPChanged($event)">
      </p-dropdown>
    </div>
  </div>
  
  <div class="row" [hidden]="includeOnlyNew.hidden">
    <label for="{{includeOnlyNew.controlId}}"
           class="col-8 sentence"
           style="padding:0.1em 0 0 1.4em;">{{includeOnlyNew.controlLabelText}}</label>
    <div class="col-4" style="display:inline-block;">
      <p-inputSwitch id="{{includeOnlyNew.controlId}}"
                     [disabled]="includeOnlyNew.disabled"
                     [(ngModel)]="includeOnlyNew.value.current"
                     (onChange)="includeOnlyNewChanged($event)"
                     [style]="{'verticalAlign':'middle'}">
      </p-inputSwitch>
    </div>
  </div>
  
  <div class="row" [hidden]="frequency.hidden">
    <label for="{{frequency.controlId}}"
           class="col-8 sentence"
           style="padding:0.1em 0 0 1.4em;">{{frequency.controlLabelText}}</label>
    <div class="col-4" style="display:inline-block;">
      <p-dropdown id="{{frequency.controlId}}"
                  [disabled]="frequency.disabled"
                  hideDropdownOnScroll
                  [(ngModel)]="frequency.value.current"
                  [options]="frequency.options"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [style]="{'width': '100%'}"
                  (onChange)="frequencyChanged($event)"
                  [hidden]="frequency.hidden">
      </p-dropdown>
    </div>
  </div>
  
  <div class="row" [hidden]="weekday.hidden">
    <label for="{{weekday.controlId}}"
           class="col-8 sentence"
           style="padding:0.1em 0 0 1.4em;">{{weekday.controlLabelText}}</label>
    <div class="col-4" style="display:inline-block;" [hidden]="weekday.hidden">
      <p-dropdown id="{{weekday.controlId}}"
                  [disabled]="weekday.disabled"
                  hideDropdownOnScroll
                  [(ngModel)]="weekday.value.current"
                  [options]="weekday.options"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [style]="{'width': '100%'}"
                  (onChange)="weekdayChanged($event)">
      </p-dropdown>
    </div>
  </div>
  
  <div class="row" [hidden]="timeString1.hidden">
    <label for="times-to-send"
           class="col-8 sentence"
           style="padding:0.1em 0 0 1.4em;">{{timeString1.controlLabelText}}</label>
    <div class="col-4" style="display:inline-block;">
      <mojo-hours-minutes 
        [(timeString)]="timeString1.value.current" 
        (onChange)="timeString1Changed($event)"
        [disabled]="timeString1.disabled"
        styleClass="mojo-hours-mins">
      </mojo-hours-minutes>
      <mojo-hours-minutes 
        [(timeString)]="timeString2.value.current"
        (onChange)="timeString2Changed($event)"
        [disabled]="timeString2.disabled"
        [hidden]="timeString2.hidden"
        styleClass="mojo-hours-mins"
        [style]="{'margin-left':'1.4em'}">
      </mojo-hours-minutes>
    </div>
  </div>
</ng-template>



<!-- **** Template for the System Defaults host **** -->

<ng-template [ngIf]="displayMode == DM.SystemDefaults">
  <div class="field grid">
    <label for="{{sendPeriodicEmailSD.controlId}}"
           class="col-fixed">{{sendPeriodicEmailSD.controlLabelText}}</label>
    <div class="col-fixed">
      <p-inputSwitch id="{{sendPeriodicEmailSD.controlId}}"
                     [(ngModel)]="sendPeriodicEmailSD.value.current"
                     (onChange)="sendPeriodicEmailSDChanged($event)">
      </p-inputSwitch>
    </div>
  </div>

  <div class="field grid" [style.display]="includeOnlyNew.hidden ? 'none' : 'flex'">
    <label for="{{includeOnlyNew.controlId}}"
          class="col-fixed"
          style="padding:0.1em 0 0 1.4em;">{{includeOnlyNew.controlLabelText}}</label>
    <div class="col-fixed">
      <p-inputSwitch id="{{includeOnlyNew.controlId}}"
                     [disabled]="includeOnlyNew.disabled"
                     [(ngModel)]="includeOnlyNew.value.current"
                     (onChange)="includeOnlyNewChanged($event)">
      </p-inputSwitch>
    </div>
  </div>

  <div class="field grid" [style.display]="frequency.hidden ? 'none' : 'flex'">
    <label for="{{frequency.controlId}}"
          class="col-fixed"
          style="padding:0.1em 0 0 1.4em;">{{frequency.controlLabelText}}</label>
    <div class="col-fixed dropdown-field">
      <p-dropdown id="{{frequency.controlId}}"
                  [disabled]="frequency.disabled"
                  hideDropdownOnScroll
                  [(ngModel)]="frequency.value.current"
                  [options]="frequency.options"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [style]="{'width': '100%'}"
                  (onChange)="frequencyChanged($event)">
      </p-dropdown>
    </div>
  </div>

  <div class="field grid" [style.display]="weekday.hidden ? 'none' : 'flex'">
    <label for="{{weekday.controlId}}"
          class="col-fixed"
          style="padding:0.1em 0 0 1.4em;">{{weekday.controlLabelText}}</label>
    <div class="col-fixed dropdown-field">
      <p-dropdown id="{{weekday.controlId}}"
                  [disabled]="weekday.disabled"
                  hideDropdownOnScroll
                  [(ngModel)]="weekday.value.current"
                  [options]="weekday.options"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [style]="{'width': '100%'}"
                  (onChange)="weekdayChanged($event)">
      </p-dropdown>
    </div>
  </div>

  <div class="field grid" [style.display]="timeString1.hidden ? 'none' : 'flex'">
    <label for="times-to-send"
          class="col-fixed"
          style="padding:0.1em 0 0 1.4em;">{{timeString1.controlLabelText}}</label>
    <div class="col-fixed">
      <mojo-hours-minutes 
        [(timeString)]="timeString1.value.current" 
        (onChange)="timeString1Changed($event)"
        [disabled]="timeString1.disabled"
        styleClass="mojo-hours-mins">
      </mojo-hours-minutes>
      <mojo-hours-minutes 
        [(timeString)]="timeString2.value.current"
        (onChange)="timeString2Changed($event)"
        [disabled]="timeString2.disabled"
        [hidden]="timeString2.hidden"
        styleClass="mojo-hours-mins"
        [style]="{'margin-left':'1.4em'}">
      </mojo-hours-minutes>
    </div>
  </div>
</ng-template>
